const updateWorkspace = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_WORKSPACE_UPDATE_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.put(`/proxy/ai/workspaces/${data.workspaceId}?customer_id=${data.customer_id}`, data);
        if (response && response.data.success) {
            //commit('SET_WORKSPACE', response.data.workspace);
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_WORKSPACE_UPDATE_LOADING", false);
    }
};

export default updateWorkspace;